import {Skeleton} from 'antd';
import styles from './TicketCard.module.scss';

export const TicketCardSkeleton = () => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.userInfo}>
          <Skeleton.Avatar active size="small" shape="circle" />
          <Skeleton.Input active size="small" style={{width: 100}} />
        </div>
      </div>
      <div className={styles.body}>
        <Skeleton.Button active size="small" style={{width: 80}} />
        <Skeleton.Button active size="small" style={{width: 120}} />
        <div className={styles.statusRow}>
          <Skeleton.Input active size="small" style={{width: 60}} />
          <Skeleton.Input active size="small" style={{width: 60}} />
        </div>
      </div>
      <div className={styles.footer}>
        <Skeleton.Input active size="small" style={{width: 80}} />
        <Skeleton.Input active size="small" style={{width: 50}} />
      </div>
    </div>
  );
};
